module.exports = __webpack_public_path__ + "img/edit.3d736658.svg";